if (!customElements.get('itm-patch-holes')) {
  customElements.define('itm-patch-holes', class extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('select');
      this.productInfo = this.closest('product-info');
      this.onVariantChange = (event) => {
        const variant = event.detail?.variant;
        if (variant) this.updatePlacement(variant.title || variant.options?.join(' ') || '');
      };
      this.productInfo?.addEventListener('theme:variant:prices-updated', this.onVariantChange);
      this.updatePlacement(this.dataset.initialVariant || '');
    }
    disconnectedCallback() {
      this.productInfo?.removeEventListener('theme:variant:prices-updated', this.onVariantChange);
    }
    updatePlacement(title) {
      const unpunched = /(?:no|without)\s*holes?/i.test(title);
      this.hidden = unpunched;
      if (this.select) this.select.disabled = unpunched;
    }
  });
}
